import React from 'react';
import { Popup } from '../../../../../components';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';







function Delete_chart_popup(props) {
    return (
        <Popup always_open title={'Remove chart'} accept_button_click={() => { props.deleteChart(props.id); props.handleClose(); }} handleClose={props.handleClose} content={
            <div style={{ width: '600px' }}><Typography style={{ width: 'calc(100% - 40px)', marginLeft: '20px', textAlign: 'center', marginTop: '60px', marginBottom: '60px' }}>Are you sure you want to remove this chart from your dashboard?</Typography>
            </div>} button_variant='icon_button' button={<AddIcon />} accept_button='Remove' />
    )
}



export default connect(ss, dd)(Delete_chart_popup);


function ss(state) {
    return {
    }
}

function dd(dispatch) {
    return {
        deleteChart: (id) => { dispatch({ type: 'REQUEST_DELETE_ANALYTICS_CHART', id: id }) }
    }
}